



























































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFilter, ISorter } from "@/models/tables";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import { DataModules } from "@/store/modules/data";
import { FilterOperators, FilterTypes, Sorters } from "@/data/table";
import { ITicketDepartment } from "@/models/tickets";

@Component
export default class SelectTicketDepartment extends Mixins(
  FilteringSortingTableStore
) {
  // Props

  @Prop({ default: null })
  public selectedId!: ITicketDepartment["id"] | null;

  @Prop({ default: "STDEPT" })
  public declare id: string;

  @Prop({ default: true })
  public declare ignoreHistory: boolean;

  @Prop({ default: true })
  public declare enableFiltering: boolean;

  @Prop({ default: () => ({}) })
  public defaultFilters!: Record<string, string>;

  // Data

  public isProcessing: any[] = [];
  public dataModule = DataModules.TICKETS_DEPARTMENTS;
  public defaults = {
    limit: 6,
    sort: {
      field: "name",
      direction: Sorters.ASCENDING
    }
  };

  public filters: IFilter[] = [
    {
      key: "name",
      label: this.$t("_.name"),
      type: FilterTypes.STRING,
      operator: FilterOperators.CONTAINS
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "name",
      label: this.$t("_.name")
    }
  ];

  // Life-cycle methods

  public created() {
    if (!this.$userCan("list_tickets_departments")) return;
    this.getData();
  }

  // Override mixin method
  public getStoreParams(params: any): Promise<any> {
    const filters = this.$_.mapKeys(
      this.defaultFilters,
      (v, key) => `filter[${key}]`
    );
    return this.$_.merge({ params: { ...filters } }, params);
  }

  public onSelect(id) {
    this.isProcessing.push(id);
    this.$emit("select", id);
  }
}
